module.exports = __webpack_public_path__ + "static/media/gallery-wall-stock-photo.ae411458.png";